import React from "react"
import "./style.scss"
import astro from "../../../images/Client/astro.png"
import biitconsulting from "../../../images/Client/biit.png"
import cosmoderm from "../../../images/Client/cosmodern.png"
import cradle from "../../../images/Client/cradle.png"
import maxis from "../../../images/Client/maxis.png"
import digi from "../../../images/Client/digi_client.png"
import corvidConsulting from "../../../images/Client/corvid.png"
import mobile from "../../../images/Client/mobile_client.png"
import petronas from "../../../images/Client/petronas.png"
import triangle from "../../../images/clients/triangle.png"
import drivex from "../../../images/Client/drivex.png"
import feitx from "../../../images/clients/feitx.png"
import Carousel from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { GatsbyImage } from "gatsby-plugin-image"

const ClientsSection = ({ title, content, clients }) => {
  const settings = {
    slidesToShow: 4,
    speed: 500,
    infinite: false,
    slidesToScroll: 4,
    rows: 2,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          rows: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          rows: 2,
        },
      },
    ],
  }
  const sectionData = {
    sectionTitle: "Clients Who Trust Us !!",
    partners: [
      { name: "astro", logo: astro },
      { name: "biitconsulting", logo: biitconsulting },
      { name: "cosmoderm", logo: cosmoderm },
      { name: "corvid_consulting", logo: corvidConsulting },
      { name: "cradle_wealth", logo: cradle },
      { name: "maxis", logo: maxis },
      { name: "digi", logo: digi },
      { name: "mobile", logo: mobile },
      { name: "petronas", logo: petronas },
      { name: "triangle", logo: triangle },
      { name: "drivex", logo: drivex },
      { name: "rfeit", logo: feitx },
    ],
  }
  return (
    <div className="homepage_clientsSection" id="clients">
      <h1 className="title">{title}</h1>
      <hr className="titleLine"/>
      <p className="content">{content}</p>
      <div className="partners">
        {/* <Carousel {...settings}>
          {clients &&
            clients.map((client, index) => {
              return (
                <div key={index} className="partner-item">
                  <GatsbyImage
                    image={client?.node?.childImageSharp?.gatsbyImageData}
                    alt={client?.node?.name}
                  />
                </div>
              )
            })}
        </Carousel> */}
        <Carousel {...settings}>
          {sectionData.partners &&
            sectionData.partners.map((client, index) => {
              return (
                <div key={index} className="partner-item">
                  <img
                    src={client?.logo}
                    alt={client?.name}
                  />
                </div>
              )
            })}
        </Carousel>
      </div>
    </div>
  )
}

export default ClientsSection
